// extracted by mini-css-extract-plugin
export default {"toggleDisplayContainer":"ToggleDisplay_toggleDisplayContainer__RoReD","active":"ToggleDisplay_active__aDLKV"};